// extracted by mini-css-extract-plugin
export default {"image":"dark_image__gCNP5 color_colorDarkBorder__4I8G6"};